import ShowMixin from '../show-mixin'
import CallToActions from './call-to-actions.vue'
import ExitIntentModal from './exit-intent-modal.vue'
import RegisterIntentModal from './register-intent-modal.vue'
import Playlist from './playlist.vue'
import ProfileSignature from './profile-signature.vue'
import ReplyWithVideo from './reply-with-video.vue'
import FormCta from './form-cta.vue'
import QuickConversationModal from '../../quick-conversation/quick-conversation-modal.vue'
import QuickConversation from '../../quick-conversation/quick-conversation.vue'
import { is_small_screen } from '../../../utils'

export default {
  components: {
    CallToActions,
    ExitIntentModal,
    RegisterIntentModal,
    FormCta,
    Playlist,
    ProfileSignature,
    QuickConversation,
    QuickConversationModal,
    ReplyWithVideo
  },
  mixins: [ShowMixin],
  computed: {
    shareOptions () {
      if (this.video.switches.show_share) {
        return {
          url: this.video.url,
          title: this.video.title
        }
      } else {
        return {}
      }
    },
    quickConversationComponent () {
      if (is_small_screen()) {
        return 'QuickConversationModal'
      }

      return 'QuickConversation'
    }
  },
  methods: {
    is_small_screen,
    assignData (video, profile, playlist) {
      this.video = video
      this.currentVideo = video
      this.profile = profile
      this.playlist = playlist
      this.onVideoLoaded()
    }
  }
}
